import {
  Alert,
  Button,
  CircularProgress,
  InputBase,
  LinearProgress,
  Snackbar,
  Typography,
} from "@mui/material";
import { Box, textTransform } from "@mui/system";
import React, { useEffect, useState } from "react";
import { styled } from "@mui/system";
import { PlaceRounded } from "@mui/icons-material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import planlist from "../plans.json";
import posthog from "posthog-js";
import {
  CalendarDays,
  CheckCircle,
  CreditCard,
  ExternalLink,
  TrendingUp,
} from "lucide-react";
import BillingsGraph from "../utils/BillingsGraph";
const Billing = () => {
  const [plan, setPlan] = useState(null);
  const [loader, setLoader] = useState(true);
  const [error_msg, setErrorMsg] = useState(null);
  const navigate = useNavigate();
  const [product_key, setProductKey] = useState("");

  const [successMsg, setSuccessMsg] = useState(null);
  const getProductkey = async () => {
    setErrorMsg(null);

    let check = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,
      {
        userId: JSON.parse(localStorage.getItem("user")).userId.S,
      }
    );

    if (check.status === 200) {
      const user___ = check.data.user;

      if (
        user___.relatedOrgs.L?.find(
          (e) =>
            e?.M.org_id?.S ===
            JSON.parse(localStorage.getItem("organization")).orgId.S
        )
      ) {
        try {
          setLoader(true);
          let key = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "productkey/redeem-product-key",
            {
              keyId: product_key,
              relatedAccount: JSON.parse(localStorage.getItem("organization"))
                .orgId.S,
            }
          );

          setLoader(false);

          if (key && key.data.updatedProductKey) {
            setLoader(true);
            let organization = await axios.post(
              process.env.REACT_APP_BACKEND_URL +
                "stripe/subscription-to-secret-plan",
              {
                customer_id: JSON.parse(localStorage.getItem("organization"))
                  .subscription_details.M.stripe_cust_id.S,
                organization_id: JSON.parse(
                  localStorage.getItem("organization")
                ).orgId.S,
                price: key.data.updatedProductKey.planId,
              }
            );

            localStorage.setItem(
              "organization",
              JSON.stringify(organization.data.organization)
            );

            let organization_ = await axios.post(
              process.env.REACT_APP_BACKEND_URL + "productkey/add-product-key",
              {
                keyId: product_key,
                organization_id: JSON.parse(
                  localStorage.getItem("organization")
                ).orgId.S,
              }
            );

            localStorage.setItem(
              "organization",
              JSON.stringify(organization_.data.organization)
            );

            check_subscription();
            setProductKey("");
            setSuccessMsg("Product key redeemed successfully");
            setTimeout(() => {
              setSuccessMsg(null);
            }, 3000);
            setLoader(false);
          }

          return;
        } catch (error) {
          if (error.response && error.response.data) {
            setErrorMsg(error.response.data.message);
          }
          setLoader(false);
        }
      } else {
        window.location.reload();
      }
    }
  };

  const manage_billing = async () => {
    posthog.capture('Clicked the "manage billing" button', {
      email: JSON.parse(localStorage.getItem("user")).email.S,
      userId: JSON.parse(localStorage.getItem("user")).userId.S,
    });
    let check = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,
      {
        userId: JSON.parse(localStorage.getItem("user")).userId.S,
      }
    );

    if (check.status === 200) {
      const user___ = check.data.user;

      if (
        user___.relatedOrgs.L?.find(
          (e) =>
            e?.M.org_id?.S ===
            JSON.parse(localStorage.getItem("organization")).orgId.S
        )
      ) {
        try {
          setLoader(true);
          let organization = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "stripe/manage-billing",
            {
              customer_id: JSON.parse(localStorage.getItem("organization"))
                .subscription_details.M.stripe_cust_id.S,
              organization_id: JSON.parse(localStorage.getItem("organization"))
                .orgId.S,
            }
          );

          window.location.href = organization.data.url;

          setLoader(false);

          return;
        } catch (error) {
          if (error.response && error.response.data) {
            setErrorMsg(error.response.data.message);
          }
          setLoader(false);
        }
      } else {
        window.location.reload();
      }
    }
  };

  const check_subscription = async () => {
    try {
      setLoader(true);
      let sub = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "stripe/check-subscription",
        {
          organization_id: JSON.parse(localStorage.getItem("organization")).orgId.S,
          customer_id: JSON.parse(localStorage.getItem("organization"))
            .subscription_details.M.stripe_cust_id.S,
        }
      );

      setPlan(sub.data);
      return;
    } catch (error) {
      if (error.response && error.response.data) {
        setErrorMsg(error.response.data.message);
      }
      setLoader(false);
    }
  };

  const [callCountsData, setCallCountsData] = useState([]);

  // Utility function to get call count for a specific month
  const getCallCountForMonth = (targetMonth) => {
    const monthData = callCountsData.find((item) => item.month === targetMonth);
    return monthData ? monthData.callCount : 0;
  };

  // Get current month's call count
  const getCurrentMonthCallCount = () => {
    const now = new Date();
    const currentMonth = `${now.getFullYear()}-${String(
      now.getMonth() + 1
    ).padStart(2, "0")}`;
    return getCallCountForMonth(currentMonth);
  };

  // Future: For bar chart, you can easily access all 6 months of data with:
  // const chartData = callCountsData.map(item => ({
  //   month: item.month,
  //   callCount: item.callCount
  // }));

  const getCallCounts = async (signal) => {
    const formatDate = (date) => date.toISOString().split("T")[0];
    const now = new Date();
    const sixMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 5, 1);
    const endOfCurrentMonth = new Date(
      now.getFullYear(),
      now.getMonth() + 1,
      0
    );
    const response = await axios.post(
      process.env.REACT_APP_BACKEND_URL + "call/get-call-counts",
      {
        organizationId: JSON.parse(localStorage.getItem("organization")).orgId
          .S,
        startDate: formatDate(sixMonthsAgo),
        endDate: formatDate(endOfCurrentMonth),
      },
      { signal }
    );
    return response.data.status === "success" && response.data.data
      ? response.data.data
      : null;
  };

  const getProductKeys = async () => {
    await axios.post(
      process.env.REACT_APP_BACKEND_URL + "productkey/get-product-keys"
    );
  };

  useEffect(() => {
    const controller = new AbortController();
    let ignore = false;

    setLoader(true);
    Promise.all([
      getCallCounts(controller.signal)
        .then((data) => {
          if (!ignore && data) setCallCountsData(data);
        })
        .catch((err) => {
          if (ignore || axios.isCancel(err)) return;
          if (err.response?.data) {
            setErrorMsg(
              (err.response.data.error || "") +
                " " +
                (err.response.data?.message || "")
            );
          }
        }),
      getProductKeys(),
      check_subscription(),
    ]).finally(() => {
      if (!ignore) setLoader(false);
    });

    return () => {
      ignore = true;
      controller.abort();
    };
  }, []);

  // Current user's role in this org (from localStorage; no API call needed)
  const currentUserType = (() => {
    try {
      const org = JSON.parse(localStorage.getItem("organization"));
      const user = JSON.parse(localStorage.getItem("user"));
      const entry = org?.users?.L?.find((u) => u?.M?.userId?.S === user?.userId?.S);
      return entry?.M?.type?.S ?? null;
    } catch {
      return null;
    }
  })();

  const used = getCurrentMonthCallCount();
  const planId = plan?.planDetails?.[0]?.plan_id;
  const planConfig = planId ? planlist[planId] : null;
  const total = planConfig?.monthlyCalls ?? null;

  const usagePercent =
    total != null && total > 0 ? ((used / total) * 100).toFixed(1) : "0";

  return (
    <div className="text-[#030229]  px-3 lg:px-0 py-4 lg:py-0">
      {currentUserType && currentUserType !== "user" ? (
        <>
          {successMsg && <Alert severity="success">{successMsg}</Alert>}
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={!!error_msg}
            autoHideDuration={6000}
            onClose={() => setErrorMsg(null)}
          >
            <Alert onClose={() => setErrorMsg(null)} severity="error" sx={{ width: "100%" }}>
              {error_msg}
            </Alert>
          </Snackbar>

          {/* {loader && (
        <div className="flex justify-center">
         <CircularProgress size={"1.2rem"}   sx={{ color: "#605BFF", animationDuration: "0.7s", }} />
        </div>
      )} */}

          <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
            {/* Header */}
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-xl font-semibold text-gray-900">
                  Current Plan
                </h2>
                <p className="text-sm text-gray-500">
                  Manage your subscription and billing information.
                </p>
              </div>

              <button onClick={manage_billing} className="px-4 py-2 rounded-lg bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700 flex items-center gap-2">
                <ExternalLink size={16} />
                Manage Billing
              </button>
            </div>

            {/* Info Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
              {/* Plan */}
              <div className="bg-gray-50 p-4 rounded-xl flex items-center gap-3">
                <div className="p-2 rounded-lg bg-indigo-100 text-indigo-600">
                  <CreditCard size={20} />
                </div>
                <div>
                  <p className="text-sm text-gray-500">Plan</p>
                  <p className="font-semibold text-gray-900">
                    {!loader && plan ? (
                      planConfig?.planName ?? planId ?? "Unknown plan"
                    ) : (
                      <CircularProgress
                        size={"1rem"}
                        sx={{
                          color: "#605BFF",
                          position: "relative",
                          top: 3,
                          left: 1,

                          animationDuration: "0.7s",
                        }}
                      />
                    )}
                  </p>
                </div>
              </div>

              {/* Status */}
              <div className="bg-gray-50 p-4 rounded-xl flex items-center gap-3">
                {!loader && plan?.subscriptionStatus === "active" && (
                  <div className="p-2 rounded-lg bg-green-100 text-green-600 ">
                    <CheckCircle size={20} className="" />
                  </div>
                )}
                {!loader && plan?.subscriptionStatus === "trialing" && (
                  <div className="p-2 rounded-lg bg-yellow-100 text-yellow-600 ">
                    <CheckCircle size={20} className="" />
                  </div>
                )}

                {!loader &&
                  plan &&
                  plan?.subscriptionStatus !== "trialing" &&
                  plan?.subscriptionStatus !== "active" && (
                    <div className="p-2 rounded-lg bg-gray-100 text-gray-600 ">
                      <CheckCircle size={20} className="" />
                    </div>
                  )}
                <div>
                  <p className="text-sm text-gray-500">Status</p>

                  {!loader && plan?.subscriptionStatus === "trialing" && (
                    <div className="flex items-center gap-2">
                      <span className="px-2 py-0.5 text-xs rounded-full bg-[rgba(91,147,255,0.1)] text-[#5B93FF]">
                        Trialing
                      </span>
                      <p className="font-semibold text-gray-900">Trialing</p>
                    </div>
                  )}

                  {!loader && plan?.subscriptionStatus === "active" && (
                    <div className="flex items-center gap-2">
                      <span className="px-2 py-0.5 text-xs rounded-full bg-green-100 text-green-700">
                        Active
                      </span>
                      <p className="font-semibold text-gray-900">Active</p>
                    </div>
                  )}

                  {!loader &&
                    plan &&
                    plan?.subscriptionStatus !== "trialing" &&
                    plan?.subscriptionStatus !== "active" && (
                      <div className="flex items-center gap-2">
                        <span className="px-2 py-0.5 text-xs rounded-full bg-[rgba(174,180,193,0.1)] text-gray-500">
                          Cancelled
                        </span>
                        <p className="font-semibold text-gray-900 text-xs relative right-1">Inactive</p>
                      </div>
                    )}
                </div>
              </div>

              {/* Next Billing */}
              <div className="bg-gray-50 p-4 rounded-xl flex items-center gap-3">
                <div className="p-2 rounded-lg bg-green-100 text-green-600">
                  <CalendarDays size={20} />
                </div>
                <div>
                  <p className="text-sm text-gray-500">Next Billing</p>
                  <p className="font-semibold text-gray-900">
                    {plan?.subscriptionEndDate
                      ? (() => {
                          const end = plan.subscriptionEndDate;
                          const date =
                            typeof end === "number"
                              ? new Date(end * 1000)
                              : new Date(end);
                          return date.toLocaleDateString("en-US", {
                            month: "short",
                            day: "numeric",
                          });
                        })()
                      : "----"}
                  </p>
                </div>
              </div>

              {/* Amount */}
              <div className="bg-gray-50 p-4 rounded-xl flex items-center gap-3">
                <div className="p-2 rounded-lg bg-purple-100 text-purple-600">
                  <TrendingUp size={20} />
                </div>
                <div>
                  <p className="text-sm text-gray-500">Amount</p>
                  <p className="font-semibold text-gray-900">
                    ${plan?.planDetails?.[0]?.amount ?? "—"}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 mt-3">
            {/* Header */}
            <h2 className="text-xl font-semibold text-gray-900">
              Monthly Usage
            </h2>
            <p className="text-sm text-gray-500 mt-1">
              Track your call usage against your monthly quota.
            </p>

            <div className="flex items-start justify-between mt-6">
              {/* Left */}
              <div>
                <p className="text-sm text-gray-600 font-semibold">Calls This Month</p>
                <p className="text-2xl font-bold text-gray-900">
                  {used} / {total ?? "—"}
                </p>
              </div>

              {/* Right */}
              <div className="text-right">
                <p className="text-sm text-gray-600 font-semibold">Usage</p>
                <p className="text-3xl font-bold text-indigo-600">
                  {usagePercent}%
                </p>
              </div>
            </div>

            {/* Progress bar */}
            <div className="mt-6">
              <div className="w-full h-3 bg-gray-200 rounded-full overflow-hidden">
                <div
                  className="h-full bg-indigo-600 rounded-full"
                  style={{ width: `${usagePercent}%` }}
                />
              </div>
            </div>

            {/* Endpoints */}
            <div className="flex items-center justify-between mt-3 text-sm text-gray-500">
              <span>0 calls</span>
              <span>{total != null ? `${total} calls` : "Quota unavailable"}</span>
            </div>
          </div>


          <div className="bg-white p-8 rounded-2xl border border-gray-200 shadow-sm mt-3">
            {/* Heading */}
            <h2 className="text-2xl font-semibold text-gray-900 mb-5">
            Historical Monthly Usage
            </h2>

            <BillingsGraph
              callCountsData={callCountsData}
              loading={loader}
              errorMsg={error_msg || ""}
            />

            </div>

          <div className="bg-white p-8 rounded-2xl border border-gray-200 shadow-sm mt-3">
            {/* Heading */}
            <h2 className="text-2xl font-semibold text-gray-900">
              Billing Management
            </h2>
            <p className="text-gray-500 mt-1">
              Access your complete billing history, update payment methods, and
              download invoices.
            </p>

            {/* Inner box */}
            <div className="bg-gray-50 rounded-2xl lg:p-12 mt-8 flex flex-col items-center text-center border border-gray-100">
              {/* Icon */}
              <CreditCard
                className="w-12 h-12 text-gray-400 mb-6"
                strokeWidth={1.5}
              />

              {/* Title */}
              <h3 className="text-xl font-semibold text-gray-900">
                Manage Your Billing
              </h3>

              {/* Subtitle */}
              <p className="text-gray-900 mt-2 text-[14px]">
                Access your Stripe customer portal to view invoices, update
                payment methods, and manage your subscription.
              </p>

              {/* Button */}
              <button
                onClick={() => {
                  window.open(
                    "https://billing.stripe.com/p/login/5kA8yS7qE4q64gU6op",
                    "_blank"
                  );
                }}
                className="mt-8 bg-indigo-600 text-white px-6 py-3 rounded-lg font-medium flex items-center gap-2 hover:bg-indigo-700 transition"
              >
                <ExternalLink className="w-4 h-4" />
                Open Billing Portal
              </button>
            </div>
          </div>

          {/* <div className="lg:text-[16px] text-[14px] font-[500] mb-4">
            Current Plan:{" "}
            {!loader && plan ? (
              planlist[plan?.planDetails[0].plan_id].planName
            ) : (
              <CircularProgress
                size={"1rem"}
                sx={{
                  color: "#605BFF",
                  position: "relative",
                  top: 3,
                  left: 1,

                  animationDuration: "0.7s",
                }}
              />
            )}
            {!loader && plan?.subscriptionStatus === "trialing" && (
              <span
                style={{ textTransform: "capitalize" }}
                className="capitalize bg-[rgba(91,147,255,0.1)] text-[#5B93FF] py-1 px-3 text-[14px] rounded-full ml-2"
              >
                {plan?.subscriptionStatus}
              </span>
            )}
            {!loader && plan?.subscriptionStatus === "active" && (
              <span
                style={{ textTransform: "capitalize" }}
                className="capitalize bg-[rgba(58,151,76,0.1)] text-[#3A974C] py-1 px-3 text-[14px] rounded-full ml-2"
              >
                {plan?.subscriptionStatus}
              </span>
            )}
            {!loader &&
              plan &&
              plan?.subscriptionStatus !== "trialing" &&
              plan?.subscriptionStatus !== "active" && (
                <span
                  style={{ textTransform: "capitalize" }}
                  className="capitalize bg-[rgba(174,180,193,0.1)] text-gray-500 py-1 px-3 text-[14px] rounded-full ml-2"
                >
                  {plan?.subscriptionStatus}
                </span>
              )}
          </div> */}

          {/* <div className="lg:w-[400px] w-full mb-5">
            <ProgressBarWithLabel
              value={getCurrentMonthCallCount()}
              max={plan && planlist[plan?.planDetails[0].plan_id].monthlyCalls}
            />
          </div> */}
          {/* <div className="space-y-3 mb-5 ">
            <div className="lg:text-[16px] text-[14px] font-[500] ">
              Login to Stripe to Manage Billing.
            </div>

            <div className="lg:text-[14px] text-[12px] pb-4 ">
              Make sure to use{" "}
              {JSON.parse(localStorage.getItem("user")).email.S} to login to the
              billing console. Need to update the billing admin? Contact Support
              at hello@twilanswer.com
            </div>

            <div className=" ">
              <Button
                variant="contained"
                  color="primary"
                  sx={{
                  py: { lg: "6px", xs: "5px" },
                  px: "20px",
                  borderRadius: "12px",
                  fontSize: { lg: "14px", xs: "12px" },
                  height: "fit",
                }}
                onClick={manage_billing}
                disabled={loader}
              >
                {loader ? (
                  <div className="flex justify-center">
                    <CircularProgress size={"1.2rem"} sx={{ color: "white" }} />
                  </div>
                ) : (
                  "Manage Billing"
                )}
              </Button>
            </div>
          </div> */}

          {/* <div className="space-y-3 ">
            <div className="lg:text-[16px] text-[14px] font-[500] underline ">
              Product Key
            </div>

            <div className="lg:text-[14px] text-[12px]  ">
              If you have a product key from one of our partners, you can enter
              it below.
            </div>

            <div className="lg:flex items-center lg:space-x-3 space-y-3 lg:space-y-0 ">

              <InputBase
                value={product_key}
                onChange={(e) => {
                  setProductKey(e.target.value);
                }}
                sx={{
                  bgcolor: "#F7F7F8",
                  width: { lg: "321px", xs: "100%" },
                  px: 2,
                  fontSize: { lg: "14px", xs: "13px" },
                }}
              />
              <Button
                variant="contained"
                  color="primary"
                  sx={{
                  py: { lg: "4px", xs: "4px" },
                  px: "1px",
                  borderRadius: "12px",
                  fontSize: { lg: "14px", xs: "12px" },
                  height: "fit",
                }}
                onClick={() => getProductkey()}
              >
                Save
              </Button>
            </div>
          </div> */}
        </>
      ) : (
        <Alert color="warning">
          <div className=" text-black-600 text-[14px] ">
            You can't view this page in this organization because your type is
            user
          </div>
        </Alert>
      )}
    </div>
  );
};

// Custom styles for LinearProgress
const CustomLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 20,
  borderRadius: 12,
  backgroundColor: "#f4f4f4", // Light gray background
  "& .MuiLinearProgress-bar": {
    borderRadius: 12,
    backgroundColor: "#a2f5a2", // Light green progress color
  },
}));

const ProgressBarWithLabel = ({ value, max }) => {
  const progress = (value / max) * 100; // Calculate progress percentage

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {/* Progress Bar */}
      <Box sx={{ flexGrow: 1 }}>
        <CustomLinearProgress variant="determinate" value={progress} />
      </Box>
      {/* Label */}
      <div className="lg:text-[14px] text-[12px] font-[500]">
        {value}/{max} Calls
      </div>
    </Box>
  );
};

export default Billing;
